import { render, staticRenderFns } from "./ProgramsConfig.vue?vue&type=template&id=22c63318&scoped=true&"
import script from "./ProgramsConfig.vue?vue&type=script&lang=js&"
export * from "./ProgramsConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProgramsConfig.vue?vue&type=style&index=1&id=22c63318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c63318",
  null
  
)

component.options.__file = "ProgramsConfig.vue"
export default component.exports